import { useState } from 'react'

import { ArrowLeft } from 'lucide-react'
import { Badge, DropdownMenu, DropdownMenuContent, DropdownMenuTrigger, Separator, SimpleAlert } from 'twyne-new.ui'

import { ActiveForm } from '@/components/form/ActiveSwitch'
import HeaderContainerForm from '@/components/headerContainer/Form'
import QuickActionsButton from '@/components/headerContainer/QuickActionsButton'
import { formatDateTime } from '@/utils'
import history from '@/utils/history'
import PageVariablesModal, { PageVariablesMenuItem } from 'components/modals/PageVariablesModal'

const pageLogicTab = {
  value: 'logic',
  label: 'Page Logic',
  content: <div className='flex flex-col gap-4'>
    <p className='twy-text-base'>
      <a
        href='http://handlebarsjs.com/'
        target='_blank'
        rel='noopener noreferrer'
        className='twy-text-accent hover:underline'
      >
        Handlebars templates
      </a>
      {' '}are fully supported in the content of pages. Variables made available for use in Handlebars are as follows:
    </p>
    <div className='border twy-border-base rounded-xs p-4 flex items-baseline gap-3'>
      <span className='font-mono text-sm twy-text-base-accent'>isMobile</span>
      <span className='twy-text-base'>Boolean value to indicate whether the request appears to be a mobile device.</span>
    </div>
    <SimpleAlert variant='info' className='my-0'>
      If you need additional variables, please contact us.
    </SimpleAlert>
  </div>,
}

export default function PageHeading({ data: page, children: options, active, onChangeActive, disabled = false, view, onChangeView }) {
  const [variablesOpen, setVariablesOpen] = useState(false)

  return <>
    <HeaderContainerForm
      title='Pages'
      data={{ ...page, createdAt: formatDateTime(page?.created_at), updatedAt: formatDateTime(page?.updated_at) }}
      onCancel={() => history.goBack()}
      extraTitle={page?.type ? <Badge variant='outline' size='lg' className='self-center'>{page.type}</Badge> : null}
    >
      {view === 'preview' ? <span
        className='flex items-center gap-2 cursor-pointer twy-text-base hover:twy-text-base-accent transition-colors'
        onClick={() => onChangeView('editor')}
      >
        <ArrowLeft size={16} />
        Back to editor
      </span> : null}
      {view === 'preview' ? <Separator orientation='vertical' className='py-5' /> : null}
      <ActiveForm active={active} onChangeActive={onChangeActive} disabled={disabled} />
      <Separator orientation='vertical' className='py-5' />
      <DropdownMenu optionsLabel='Options' modal={false}>
        <DropdownMenuTrigger className='flex items-center gap-1'>
          <QuickActionsButton />
        </DropdownMenuTrigger>
        <DropdownMenuContent align='start'>
          <PageVariablesMenuItem onSelect={() => setVariablesOpen(true)} />
          {options}
        </DropdownMenuContent>
      </DropdownMenu>
    </HeaderContainerForm>
    <PageVariablesModal tabs={[pageLogicTab]} open={variablesOpen} onOpenChange={setVariablesOpen} />
  </>
}
